import React from 'react';
import { Box, Typography, Container } from '@mui/material';

interface FeaturesProps {
  sectionRef: React.RefObject<HTMLDivElement | null>;
}

const Features: React.FC<FeaturesProps> = ({ sectionRef }) => {
  return (
    <Box
      ref={sectionRef}
      sx={{
        minHeight: '100vh',
        position: 'relative',
        zIndex: 2,
        background: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(10px)',
        py: 8,
        mt: 4,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            color: '#000050',
            textAlign: 'center',
            mb: 6,
            fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
          }}
        >
          Our Features
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 4,
          }}
        >
          {[
            {
              title: 'Enterprise Solutions',
              description: 'Comprehensive enterprise-grade software solutions tailored to your business needs.',
            },
            {
              title: 'Cloud Integration',
              description: 'Seamless cloud integration with advanced security and scalability features.',
            },
            {
              title: 'EdTech',
              description: 'Comprehensive tech education plans prodived our highly experienced SMe',
            },
          ].map((feature, index) => (
            <Box
              key={index}
              sx={{
                p: 4,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0,0,80,0.2)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  background: 'rgba(0,0,80,0.15)',
                },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: '#000050',
                  mb: 2,
                  fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
                  fontWeight: 500,
                }}
              >
                {feature.title}
              </Typography>
              <Typography
                sx={{
                  color: '#000050',
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  lineHeight: 1.6,
                }}
              >
                {feature.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Features; 